package com.milta.core.localization.translations.fr

import com.milta.core.localization.ErrorStrings

internal val Errors = ErrorStrings(
    generic = "Une erreur est survenue",
    error = "Erreur",
    fieldRequired = "Ce champ est obligatoire",
    invalidEmail = "Adresse email invalide",
    fileTooLarge = "Fichier trop volumineux. Choisissez un fichier plus léger.",
)
